import actions from './actions'
import getters from './getters'
import { getInitialState } from './helper'
import mutations from './mutations'

export default () => ({
  namespaced: true,
  state: getInitialState(),
  mutations,
  getters,
  actions,
})
